import {Copy07Icon, FileSearch02Icon, FileX02Icon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {useMedicalReportTextAreaStore} from '../../stores/medicalReportTextAreaStore'
import {useMedicalPreviousReportContext} from '../../hooks/useMedicalPreviousReportContext'
import {StyledSplitViewButton} from './style'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const MedicalReportSplitViewButton = ({
    currentField,
    onCopyPaste
}: {
    currentField: string
    onCopyPaste: () => void
}) => {
    const {t} = useTranslation()
    const {isSplitView, openSplitView, disableSplit} = useMedicalReportTextAreaStore()
    const {previousReport} = useMedicalPreviousReportContext()

    return previousReport ? (
        <Flexbox align="center">
            <StyledSplitViewButton
                type="button"
                variant="ghost"
                size="sm"
                $isActive={isSplitView}
                onClick={isSplitView ? disableSplit : () => openSplitView(currentField)}
            >
                {isSplitView ? (
                    <>
                        <FileX02Icon />
                        {t('medical_records:hide_previous_report')}
                    </>
                ) : (
                    <>
                        <FileSearch02Icon />
                        {t('medical_records:show_previous_report')}
                    </>
                )}
            </StyledSplitViewButton>
            <StyledSplitViewButton type="button" variant="ghost" size="sm" $isActive={false} onClick={onCopyPaste}>
                <Copy07Icon />
                {t('medical_records:copy_and_paste_previous_report')}
            </StyledSplitViewButton>
        </Flexbox>
    ) : null
}
